import React from 'react';

const SimpleModal = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="edit-student-modal-edit" onClick={e => e.stopPropagation()} style={{ maxWidth: 400, width: '90%' }}>
        <div className="edit-student-modal-content">
          {title && <h2 style={{ textAlign: 'center', marginBottom: 16 }}>{title}</h2>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default SimpleModal;
